import { ConversationTrainingLabelSchema } from "@redotech/redo-model/conversation-training-label/conversation-training-label-definition";
import { z } from "zod";

export const getConversationTrainingLabelsForTeam = {
  input: z.object({ trainingSetId: z.string() }),
  output: z.array(ConversationTrainingLabelSchema),
};
